import { render } from "./itemSlider.vue?vue&type=template&id=78833062&scoped=true"
import script from "./itemSlider.vue?vue&type=script&lang=js"
export * from "./itemSlider.vue?vue&type=script&lang=js"

import "./itemSlider.vue?vue&type=style&index=0&id=78833062&scoped=true&lang=css"

import exportComponent from "C:\\paginascedis\\general\\cedispage2.0_general_vipla\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78833062"]])

export default __exports__